/**
 * Paths where GET /accounts/user-credits/ should not run — incomplete onboarding / role
 * selection can return 401 and trigger the global session-expired handler.
 */
export function shouldDeferUserCreditsFetch(pathname: string): boolean {
  return (
    pathname.startsWith("/user-role") ||
    pathname.startsWith("/onboarding") ||
    pathname.startsWith("/company-details")
  );
}
